import { useMemo } from 'react'
import ReactDatePicker from 'react-datepicker'
import NightsList from '../../components/NightsList';
import { addDays, addMonths, endOfMonth } from 'date-fns';
import { useSelector } from 'react-redux';
import { selectMonthAhead } from '../../../mainFilter/selectors';
import { t } from '../../../../utilities/translator';

interface RangeTypeProps {
  onDayClick: (days: number) => void;
  selectedDays: number[];
  onDateChange: (dates: [Date, Date]) => void;
  startDate: Date;
  endDate: Date;
  weekendsOnly: boolean;
  onWeekendsOnlyClick: () => void;
  daysInterval: number;
}

const RangeType = ({
  onDayClick,
  selectedDays,
  onDateChange,
  startDate,
  endDate,
  weekendsOnly,
  onWeekendsOnlyClick,
  daysInterval,
}: RangeTypeProps) => {
  const monthAhead = useSelector(selectMonthAhead) || 12;
  const datePickerEndDate = useMemo(() => addMonths(new Date(), monthAhead), [monthAhead]);
  const endDateWithLastDay = endOfMonth(datePickerEndDate);

  const renderCustomDay = (day: number) => {
    return (
      <div className="custom-day">
        <div className="day-label">
          {day}
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="label-large text-start font-medium">{t('mainFilter.date_range_label')}</div>

      <NightsList
        onChange={onDayClick}
        selected={selectedDays}
        weekendsOnly={weekendsOnly}
        onWeekendsChange={onWeekendsOnlyClick}
        daysInterval={daysInterval}
        variant="gray"
      />

      <ReactDatePicker
        onChange={onDateChange}
        startDate={startDate}
        endDate={endDate}
        minDate={addDays(new Date(), 1)}
        maxDate={endDateWithLastDay}
        monthsShown={monthAhead}
        disabledKeyboardNavigation
        selectsRange
        inline
        shouldCloseOnSelect={false}
        openToDate={window.innerWidth < 768 ? addDays(new Date(), 2) : undefined}
        renderDayContents={renderCustomDay}
        calendarClassName="datepicker-range"
      />
    </>
  )
}

export default RangeType
